module.exports = __webpack_public_path__ + "img/esquemaE.6d8e34f6.svg";